import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Injector, Input, OnDestroy, ViewChild } from '@angular/core';
import { ShortcutKeyDesc } from '../../../interface/placeholder';
import { addResizeListener, removeResizeListener } from '../../../utils/resize-event';

const ICON_SIZE = 280;  // 图标大小，需要与样式文件同步修改
const SHORTCUTS_ITEM_HEIGHT = 32;  // 快捷键列表条目高度，需要与样式文件同步修改

/**
 * 标签页为空时的占位元素
 * @remarks 展示一些常用的快捷键以及一些快捷操作的链接
 */
@Component({
  selector: 'center-panel--placeholder',
  templateUrl: './placeholder.component.html'
})
export class PlaceholderComponent implements AfterViewInit, OnDestroy {

  /** 快捷键列表 */
  @Input() set shortcuts(shortcuts: ShortcutKeyDesc[]) {
    this._shortcuts = shortcuts;
    this.totalHeight = this.getTotalHeight();
    this.inited && this.handleResize();
  }
  get shortcuts(): ShortcutKeyDesc[] {
    return this._shortcuts;
  }
  private _shortcuts: ShortcutKeyDesc[] = [];

  @Input() set verticalPos(verticalPos: number) {
    if (verticalPos < 0 || verticalPos > 1) {
      return;
    }
    this._verticalPos = verticalPos;
    this.inited && this.handleResize();
  }
  get verticalPos(): number {
    return this._verticalPos;
  }
  private _verticalPos: number = 0.4;

  get hasShortcut(): boolean {
    return this.shortcuts && this.shortcuts.length > 0;
  }

  /** 总体的高度：图标高度 + 快捷键列表高度 */
  private totalHeight: number = -1;
  /** 页面元素初始化后监听大小变化 */
  private inited: boolean = false;
  /** 是否显示快捷键列表 */
  showShortcuts: boolean = true;
  /** 外层样式，用来设定垂直高度 */
  wrapperStyle: any = {};

  @ViewChild("container") containerEl: ElementRef;

  constructor(
    private injector: Injector,  // 防止依赖变更导致需要重新打包
    private cd: ChangeDetectorRef
  ) { }

  private getTotalHeight(): number {
    const shortcutsListSize = this.shortcuts ? this.shortcuts.length : 0;
    return ICON_SIZE + SHORTCUTS_ITEM_HEIGHT * shortcutsListSize;
  }

  private handleResize = () => {
    // 如果总体高度大于可见高度，则隐藏快捷键列表，只显示大图标
    const container = this.containerEl.nativeElement as HTMLElement;
    const clientHeight = container.clientHeight;
    if (clientHeight < this.totalHeight) {
      this.showShortcuts = false;
    } else {
      this.showShortcuts = true;
    }
    // 计算上方间距大小
    const contentHeight = this.showShortcuts ? this.totalHeight : ICON_SIZE;
    const totalMarginSize = clientHeight - contentHeight;
    if (totalMarginSize <= 0) {
      this.wrapperStyle = {
        "margin-top": '0px'
      };
    } else {
      const marginTop = Math.floor(
        totalMarginSize * this.verticalPos
      );
      this.wrapperStyle = {
        "margin-top": `${marginTop}px`
      };
    }
    this.cd.detectChanges();
  };

  ngAfterViewInit(): void {
    this.inited = true;
    this.handleResize();
    addResizeListener(this.containerEl.nativeElement, this.handleResize);
  }

  ngOnDestroy(): void {
    removeResizeListener(this.containerEl.nativeElement, this.handleResize);
  }

}
